module.exports = __webpack_public_path__ + "img/Flag_of_the_Isle_of_Man.18908dd2.svg";